// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AmazonSquareFilledSvg from "@fishx/icons-svg/es/asn/AmazonSquareFilled";
import FishxIcon from '../components/FishxIcon';

var AmazonSquareFilled = function AmazonSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AmazonSquareFilledSvg
  }));
};

AmazonSquareFilled.displayName = 'AmazonSquareFilled';
export default React.forwardRef(AmazonSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AmazonSquareFilled.js
// module id = 1986
// module chunks = 0